import './style.scss';

import { useSelector } from 'react-redux';
import {Navigate} from "react-router-dom";
import {route as SWITCH_DISTRICT_ROUTE} from "../switchDistricts";
import {route as MY_REPORTS_ROUTE} from "../myReports";

export const route = '/dashboard';

const Dashboard = (props) => {
  const user = useSelector((state) => state.session.currentUser);
  const userComposite = useSelector((state) => state.session.currentUserComposite);
  const session = useSelector((state) => state.session.sessionData);
  const sessionExpireDate = useSelector((state) => state.session.sessionExpireDate);
  const currentDistrict = useSelector((state) => state.districts.currentDistrict);

  return <Navigate to={((currentDistrict) ? MY_REPORTS_ROUTE : SWITCH_DISTRICT_ROUTE)}/>;
};


export default Dashboard;